module.exports = __webpack_public_path__ + "static/the-conservationist-81f5b830eb0cd1eb65ca942260242a79.jpg";